import { useWebHaptics } from "web-haptics/react";

export const useHaptics = () => {
  return useWebHaptics();
};
